import React from "react";
import "./mobile-module-header.css";
import IconifyIcon from "../IconifyIcon";
import SearchInput from "../FormElements/SearchInput";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";

interface MobileModuleHeaderProps {
  title: string;
  titleIcon?: string;
  hasFilters: boolean;
  isDowloadable: boolean;
  hasSearch: boolean;
  hasNewButton: boolean;
  searchValue?: string;
  setSearchValue?: React.Dispatch<React.SetStateAction<string>>;
  isGuardLog?: boolean;
  registerType?: "manual" | "qr";
  setRegisterType?: (registerType: "manual" | "qr") => void;
  newButtonAction?: () => void;
}

const MobileModuleHeader = ({
  title,
  titleIcon,
  searchValue,
  setSearchValue,
  hasSearch,
  hasNewButton,
  hasFilters,
  isDowloadable,
  isGuardLog,
  registerType,
  setRegisterType,
  newButtonAction,
}: MobileModuleHeaderProps) => {
  const labels = useAppSelector(selectLabels);

  const changeRegisterType = (type: "manual" | "qr") => {
    if (setRegisterType) {
      setRegisterType(type);
    }
  };

  return (
    <div
      className="mobile-module-header-container"
      style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 4px 8px" }}
    >
      <div className="mob-header-section">
        <div className="flex align-items-center gap-5">
          {titleIcon && (
            <div
              className="flex align-items-center justify-content-center"
              style={{ width: 24, height: 24 }}
            >
              <IconifyIcon icon={titleIcon} fontSize={24} />
            </div>
          )}
          <p className="font-24 font-w-500">{title}</p>
        </div>
        {!isGuardLog ? (
          <div className="flex align-items-center gap-6">
            {!hasSearch && hasFilters && (
              <div
                className="flex align-items-center justify-content-center"
                style={{ width: 26, height: 26 }}
              >
                <IconifyIcon icon={"ri:filter-fill"} fontSize={26} />
              </div>
            )}
            {!hasSearch && isDowloadable && (
              <div
                className="flex align-items-center justify-content-center"
                style={{ width: 26, height: 26 }}
              >
                <IconifyIcon icon={"fa-solid:file-download"} fontSize={26} />
              </div>
            )}
            {hasNewButton && (
              <div
                className="flex align-items-center justify-content-center"
                style={{ width: 26, height: 26 }}
                onClick={newButtonAction}
              >
                <IconifyIcon icon={"fa6-solid:circle-plus"} fontSize={26} />
              </div>
            )}
          </div>
        ) : (
          <div>
            {/* <p style={{ color: "white" }}>{labels.visitors_inside}: 0</p> */}
          </div>
        )}
      </div>
      {!isGuardLog ? (
        <>
          {hasSearch && (
            <div className={"mob-header-section" + (hasFilters || isDowloadable ? " gap-6" : "")}>
              <SearchInput
                value={searchValue || ""}
                setValue={setSearchValue || (() => {})}
                size={"small"}
              />
              <div className="flex align-items-center gap-6">
                {hasFilters && (
                  <div
                    className="flex align-items-center justify-content-center"
                    style={{ width: 26, height: 26 }}
                  >
                    <IconifyIcon icon={"ri:filter-fill"} fontSize={26} />
                  </div>
                )}
                {isDowloadable && (
                  <div
                    className="flex align-items-center justify-content-center"
                    style={{ width: 26, height: 26 }}
                  >
                    <IconifyIcon
                      icon={"fa-solid:file-download"}
                      fontSize={22}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="mob-header-section gap-6">
          <div className="w-50">
            <div
              style={{
                display: "flex",
                boxSizing: "border-box",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: 40,
                borderRadius: 4,
                borderColor:
                  registerType === "manual" ? "#c4c4c4" : "transparent",
                borderStyle: "solid",
                borderWidth: 1,
                backgroundColor:
                  registerType === "manual"
                    ? "white"
                    : "rgba(255, 255, 255, 1)",
                gap: 4,
                color: registerType !== "manual" ? "#666" : "",
              }}
              className={registerType === "manual" ? "primary-color" : ""}
              onClick={
                registerType === "manual"
                  ? () => {}
                  : () => changeRegisterType("manual")
              }
            >
              <IconifyIcon icon={"solar:clipboard-bold"} />
              <p style={{ fontWeight: registerType === "manual" ? 500 : "" }}>
                {labels.manual_log}
              </p>
            </div>
          </div>
          <div className="w-50">
            <div
              style={{
                display: "flex",
                boxSizing: "border-box",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: 40,
                borderRadius: 4,
                borderColor: registerType === "qr" ? "#c4c4c4" : "transparent",
                borderStyle: "solid",
                borderWidth: 1,
                backgroundColor:
                  registerType === "qr" ? "white" : "rgba(255, 255, 255, 1)",
                gap: 4,
                color: registerType !== "qr" ? "#666" : "",
              }}
              className={registerType === "qr" ? "primary-color" : ""}
              onClick={
                registerType === "qr"
                  ? () => {}
                  : () => changeRegisterType("qr")
              }
            >
              <IconifyIcon icon={"solar:qr-code-bold"} />
              <p style={{ fontWeight: registerType === "qr" ? 500 : "" }}>
                {labels.qr_code}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileModuleHeader;
